import React, { useEffect, useState } from "react";
import { SnackbarProps } from "../interface/Success_SnackBar_Interface";
import "../styles/SuccessSnackPopup_Style.css";
import snackTickImg from "../assets/images/snack_tick.png";
import snackCloseImg from "../assets/images/snack_close.png";
const SuccessSnackPopUp: React.FC<SnackbarProps> = ({ message, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!visible) return null;

  return (
    <div className="snackbarContainer">
      {/* Left border for success message */}
      <div className="leftBorder"></div>

      {/* Image and Text */}
      <div className="snackbarContent">
        <img src={snackTickImg} alt="Success" className="icon" />
        <p className="text-bar">{message}</p>
      </div>

      {/* Close Icon */}
      <button
        onClick={() => {
          setVisible(false);
          onClose();
        }}
        className="closeButton"
      >
        <img src={snackCloseImg} alt="Close" className="closeIcon" />
      </button>
    </div>
  );
};

export default SuccessSnackPopUp;
